export default __webpack_public_path__ + "static/media/avatar.2420d0b8.svg";